import { render, staticRenderFns } from "./orderDetial2.vue?vue&type=template&id=1c500a64&scoped=true"
import script from "./orderDetial2.vue?vue&type=script&lang=js"
export * from "./orderDetial2.vue?vue&type=script&lang=js"
import style0 from "./orderDetial2.vue?vue&type=style&index=0&id=1c500a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c500a64",
  null
  
)

export default component.exports